import { ReactComponent as TemplateIcon } from "assets/svg/acoustic.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const erasAndGenres: SurveyTemplate = {
  icon: <TemplateIcon />,
  title: "Acoustic Version",
  description:
    "Allow your fans to vote on which song you'll be playing an acoustic version of today.",
  templateId: "erasAndGenres",
  template: (v, formState) => ({
    fields: {
      description: {
        content: {
          en: "Acoustic Version",
        },
      },
      ...getContestDefaults(formState),
    },
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-livestream-038a1f"
        : "pp-livestream-b4eefb",
    fields: [
      {
        name: "date",
        type: "text",
        label: "When does your livestream take place?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.date ? false : "This field cannot be left blank",
      },
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
